<template>
    <b-modal v-model="isModalOpen" hide-footer size="xl"
        title="Verknüpfte Dateien" @hide="reset()">
        <div class="record-note-files-modal loading-content-container">
            <div v-if="noteFilesLoading > 0" class="loading-overlay d-flex justify-content-center pt-5">
                <csp-loading-indicator/>
            </div>

            <csp-record-detail-document-upload
                :damage-record-note-id="noteId"
                :record-id="recordId"
                @upload-success="onUploadSuccess"/>
            <div class="clear-float mb-3"></div>

            <b-alert v-if="noteFilesLoading === 0 && recordFilesForTable.length === 0"
                show variant="info">
                Keine Dokumente vorhanden
            </b-alert>

            <b-table v-if="noteFilesLoading === 0 && recordFilesForTable.length > 0"
                :fields="fileTableFields" :items="recordFilesForTable" :responsive="true"
                striped>
                <template v-slot:table-colgroup="scope">
                    <col
                        v-for="field in scope.fields"
                        :key="field.key"
                        :style="{ width: field.width ?? 'auto' }">
                </template>
                <template v-slot:cell(dateSet)="data">
                    {{ formatDateTime(data.value) }}
                </template>
                <template v-slot:cell(hideForGroup)="data">
                    <csp-hide-for-group
                        :default-value="data.value"
                        :options="hideForGroupOptions"
                        :record-id="recordId"/>
                </template>
                <template v-slot:cell(actions)="data">
                    <div class="table-actions" style="text-align: right">
                        <a v-if="canPreviewDocuments" href="#" title="Vorschau"
                            @click.prevent="showFile(data.item.fileId)">
                            <i class="inticon-autoclaim_detail"/>
                        </a>
                        <a :href="getDownloadFileUrl(data.item.fileId)" title="Datei herunterladen">
                            <i class="inticon-autoclaim_einzeldownload"/>
                        </a>
                    </div>
                </template>
            </b-table>
        </div>
    </b-modal>
</template>

<script>
    import Container from '@services/Container';
    import DocumentUploadModal from '@desktop/components/record/document/DocumentUploadModal';
    import {formatDateTime} from '@js/functions/date';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'DocumentListModal',
        components: {
            'csp-record-detail-document-upload': DocumentUploadModal,
        },
        props: {
            recordId: {
                type: Number,
                required: true,
            },
            noteId: {
                type: Number,
                default: null,
            },
            hideForGroupOptions: {
                type: Array,
                default: () => [],
            },
        },
        emits: [
            'reset',
            'upload-success',
        ],
        data() {
            return {
                fileTableFields: [
                    {
                        key: 'fileCategoryName',
                        label: 'Kategorie',
                        width: '180px',
                    },
                    {
                        key: 'fileName',
                        label: 'Dateiname',
                    },
                    {
                        key: 'dateSet',
                        label: 'Datum',
                        width: '130px',
                    },
                    {
                        key: 'createdByName',
                        label: 'von',
                        width: '200px',
                    },
                    {
                        key: 'hideForGroup',
                        label: 'Sichtbarkeit',
                        width: '200px',
                    },
                    {
                        key: 'actions',
                        label: '',
                        width: '75px',
                    },
                ],
                noteFiles: [],
                isModalOpen: true,
                noteFilesLoading: 0,
                canPreviewDocuments: false,
            }
        },
        computed: {
            recordFilesForTable() {
                const filesForTable = [];

                this.noteFiles.forEach((data) => {
                    filesForTable.push({
                        fileId: data.id,
                        ...data.attributes,
                    });
                });
                return filesForTable;
            },
        },
        created() {
            this.loadDocumentPermissions();
            this.loadNoteFiles();
        },
        methods: {
            formatDateTime,
            getDownloadFileUrl(fileId) {
                return recordRepository.buildNoteFileDownloadUrl(this.recordId, this.noteId, fileId);
            },
            loadNoteFiles() {
                this.noteFilesLoading++;
                recordRepository.getNoteFiles(this.recordId, this.noteId)
                    .then(response => {
                        this.noteFiles = response.data;
                    })
                    .finally(() => {
                        this.noteFilesLoading--;
                    });
            },
            loadDocumentPermissions() {
                this.noteFilesLoading++;
                recordRepository.loadDocumentsOverview(this.recordId).then(response => {
                    this.canPreviewDocuments = response.data.meta.permissions.canPreviewDocuments;
                    this.noteFilesLoading--;
                })
            },
            onUploadSuccess(event) {
                this.$emit('upload-success', event)
                this.loadNoteFiles()
            },
            reset() {
                this.$emit('reset');
            },
            showFile(fileId) {
                const url = recordRepository.buildNoteFilePreviewUrl(this.recordId, this.noteId, fileId);
                window.open(url, '_blank')
            },
        },
    }
</script>
